var React = require('react');

function HatchingIcon (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("pattern",{"id":"diagonal-hatch-UNIQUE_ID","width":"7","height":"7","patternTransform":"rotate(-45 0 0)","patternUnits":"userSpaceOnUse"},React.createElement("line",{"x1":"0","y1":"0","x2":"0","y2":"7","className":"primary-stroke","strokeWidth":"4"}))),React.createElement("rect",{"x":"0","y":"0","width":"100%","height":"100%","fill":"url(#diagonal-hatch-UNIQUE_ID)","key":1})]);
}

HatchingIcon.defaultProps = {"fill":"none","className":"button-hatch-pattern"};

module.exports = HatchingIcon;

HatchingIcon.default = HatchingIcon;
